import { render, staticRenderFns } from "./SubconInvoiceView.vue?vue&type=template&id=3b586020"
import script from "./SubconInvoiceView.vue?vue&type=script&lang=js"
export * from "./SubconInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports